<template>
  <el-table
    :data="newList"
    border=""
    height="480px"
    highlight-current-row
    :row-class-name="tableRowClassName"
    @current-change="handleCurrentChange">
    <el-table-column
      prop="idx"
      width="50">
    </el-table-column>
    <el-table-column
      prop="productName"
      label="商品名称">
    </el-table-column>
    <el-table-column label="仓库数">
      <el-table-column
        width="100"
        prop="lowSafetyStockCount"
        :formatter="row=> row.lowSafetyStockCount + '个'"
        label="低于安全库存">
      </el-table-column>
      <el-table-column
        width="100"
        prop="highSafetyStockCount"
        :formatter="row=> row.highSafetyStockCount + '个'"
        label="高于安全库存">
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'SafeSkuTable',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  },
  computed: {
    newList() {
      return this.list.map((i, idx) => {
        return {
          ...i,
          idx: idx + 21
        }
      })
    }
  },
  methods: {
    handleCurrentChange(val) {
      console.log(val)
      this.$emit('setIndex', val.idx - 1)
    },
    tableRowClassName({ row }) {
      if (row.lowSafetyStockCount > 0) {
        return 'warning-row'
      }
      return ''
    }
  }
}
</script>
<style lang="stylus">
  .el-table .warning-row {
    background: oldlace !important;
  }
</style>

